import React from 'react'
import Button from './Button'


function ButtonList() {
  return (
    <div className='flex font-semibold'>
    <Button name="All"/>
    <Button name="songs"/>
    <Button name="Live"/>
    <Button name="Soccer"/>
    <Button name="News"/>
    <Button name="Cooking"/>
    <Button name="Valentines"/>
    <Button name="Entertainement"/>
    <Button name="Bikes"/>
    <Button name="Love"/>
    <Button name="Study"/>
    <Button name="Works"/>
    <Button name="Comedy"/>
    <Button name="Coding"/>
    <Button name="Web"/>
    
   
    </div>
  )
}

export default ButtonList